
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('g',{attrs:{"transform":"translate(-403 -56)"}},[_c('rect',{attrs:{"width":"2","height":"16","rx":"1","transform":"translate(421 60)"}}),_c('rect',{attrs:{"width":"2","height":"16","rx":"1","transform":"translate(406 60)"}}),_c('rect',{attrs:{"width":"4","height":"17","rx":"1","transform":"rotate(90 181.5 241.5)"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      